// Project detail registry. Each entry describes one full editorial
// case-study page. The renderer in `pages/ProjectDetail.jsx` reads
// the `sections` array and walks through them in order.
//
// Image paths are relative to `imageBase`. The file will resolve to
// `<base><image>` so subfolder assets (sketches, BTS) can be
// addressed with a `sketch/` or `bts/` prefix.

const PROJECT_DETAILS = {};

export const getProjectDetail = (slug) => PROJECT_DETAILS[slug] || null;
